/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MonitEntityAssetTechOrderBy = {
    EntityId: 'entity_id',
    Asset: 'asset',
    SourceAsset: 'source_asset',
    Port: 'port',
    TechName: 'tech_name',
    Shared: 'shared',
    Found: 'found',
    Created: 'created',
    Updated: 'updated',
    Version: 'version'
} as const;
export type MonitEntityAssetTechOrderBy = typeof MonitEntityAssetTechOrderBy[keyof typeof MonitEntityAssetTechOrderBy];


export function MonitEntityAssetTechOrderByFromJSON(json: any): MonitEntityAssetTechOrderBy {
    return MonitEntityAssetTechOrderByFromJSONTyped(json, false);
}

export function MonitEntityAssetTechOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityAssetTechOrderBy {
    return json as MonitEntityAssetTechOrderBy;
}

export function MonitEntityAssetTechOrderByToJSON(value?: MonitEntityAssetTechOrderBy | null): any {
    return value as any;
}

